/* Mouillette · Test de perfume v2
   Usa los metacampos de cada producto (familias, momento, intensidad, proyección,
   duración, concentración, volumen, ocasión, notas y "es para ti") tanto para
   puntuar como para explicarle al cliente por qué se lo recomendamos. */
(function () {
  var root = document.querySelector('[data-quiz-root-v2]');
  if (!root) return;
  var MOU = window.MOU || {};
  var data = (function () {
    try { return JSON.parse((document.getElementById('QuizProducts') || {}).textContent || '[]'); } catch (e) { return []; }
  })();

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var track = function (name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var list = function (v) { return Array.isArray(v) ? v : (v ? [v] : []); };
  var join = function (arr, sep) { return list(arr).filter(Boolean).join(sep || ', '); };

  var STEPS = [
    { key: 'who', q: '¿Para quién es el perfume?', help: 'Si es un regalo, lo tenemos en cuenta para que aciertes.', options: [
      ['ella', 'Para mí · ella'], ['el', 'Para mí · él'], ['regalo-ella', 'Un regalo para ella'], ['regalo-el', 'Un regalo para él'], ['cualquiera', 'Me da igual', 'Muéstrame lo que mejor me quede']] },
    { key: 'climate', q: '¿En qué clima lo vas a usar?', help: 'El calor multiplica lo dulce y lo denso. El frío lo apaga. Esto cambia todo.', options: [
      ['caliente', 'Tierra caliente', 'Barranquilla, Cartagena, Cali, Santa Marta'], ['templado', 'Clima templado', 'Medellín, Pereira, Bucaramanga'], ['frio', 'Clima frío', 'Bogotá, Tunja, Manizales'], ['viajo', 'Me muevo entre climas']] },
    { key: 'occasion', q: '¿Dónde lo vas a usar más?', help: 'Piensa en el plan donde más quieres oler bien.', options: [
      ['diario', 'Todos los días', 'Un perfume que funcione para todo'], ['oficina', 'Oficina y reuniones', 'Que se note, sin invadir'], ['noche', 'Salidas de noche', 'Rumba, conciertos, planes largos'], ['cita', 'Citas', 'Que te recuerden de cerca'], ['eventos', 'Eventos especiales', 'Matrimonios, cenas, grados']] },
    { key: 'likes', multi: 2, exclusive: 'nose', q: '¿Qué olores te gustan?', help: 'Elige hasta 2. Piensa en cosas reales, no en perfumes.', options: [
      ['fresco', 'Recién bañado', 'Limón, mar, menta, jabón limpio'], ['dulce', 'Postre', 'Vainilla, caramelo, chocolate, café con leche'], ['floral', 'Flores', 'Rosa, jazmín, flores blancas'], ['madera', 'Madera y cuero', 'Cedro, sándalo, tabaco, vetiver'], ['especiado', 'Especias y ámbar', 'Canela, pimienta, incienso'], ['nose', 'No sé todavía', 'Recomiéndenme ustedes']] },
    { key: 'dislikes', multi: 3, exclusive: 'nada', q: '¿Qué NO soportas en un perfume?', help: 'Tan importante como lo que te gusta. Puedes marcar varias.', options: [
      ['muy-dulce', 'Que sea empalagoso'], ['muy-floral', 'Que huela a flores'], ['muy-fuerte', 'Que sea muy fuerte', 'Me duele la cabeza o incomoda a otros'], ['nada', 'Nada en especial']] },
    { key: 'effect', q: '¿Qué quieres transmitir?', help: 'Lo que alguien pensaría de ti al olerte.', options: [
      ['frescura', 'Limpio y fresco'], ['dulzura', 'Cálido y cercano'], ['elegancia', 'Elegante y pulido'], ['misterio', 'Misterioso y seductor'], ['presencia', 'Seguro, que se note']] },
    { key: 'presence', q: '¿Qué tan fuerte lo quieres?', help: 'Íntimo se descubre de cerca. Con estela se queda en el cuarto cuando te vas.', options: [
      ['sutil', 'Íntimo', 'Solo quien se acerca lo nota'], ['notorio', 'Notorio', 'Se siente en la mesa'], ['estela', 'Que deje estela', 'Llega antes que tú y se queda']] },
    { key: 'budget', q: '¿Cuánto quieres invertir?', help: 'Todos son de alta concentración.', options: [
      ['lt150', 'Hasta $150.000'], ['150-200', '$150.000 – $200.000'], ['gt200', 'Más de $200.000'], ['igual', 'Lo que mejor me quede']] },
  ];
  var BUDGET = { lt150: [0, 15000000], '150-200': [15000001, 20000000], gt200: [20000001, Infinity] };
  var LIKE_FAM = {
    fresco: ['Fresca', 'Aromática', 'Cítrica'],
    dulce: ['Gourmand', 'Dulce'],
    floral: ['Floral'],
    madera: ['Amaderada', 'Aromática'],
    especiado: ['Ámbar', 'Especiada'],
  };
  var LIKE_WORD = { fresco: 'lo fresco', dulce: 'lo dulce', floral: 'las flores', madera: 'la madera', especiado: 'las especias' };
  var INT = ['intima', 'notoria', 'estela'];
  var PRES = { sutil: 'intima', notorio: 'notoria', estela: 'estela' };
  var PRES_WORD = { sutil: 'de cercanía', notorio: 'de presencia', estela: 'de estela' };
  var PROFILE = {
    frescura: ['Fresco', 'Te gusta oler limpio, ligero y actual. Tu perfume ideal acompaña sin robarse la escena.'],
    dulzura: ['Cálido', 'Buscas un perfume que abrace. Cercano, cálido y fácil de querer.'],
    elegancia: ['Elegante', 'Prefieres lo pulido. Un perfume que se lea adulto, seguro y bien vestido.'],
    misterio: ['Nocturno', 'Te atrae lo que no se explica del todo. Fondo oscuro, piel y un poco de intriga.'],
    presencia: ['Magnético', 'Quieres que se note cuando llegas. Proyección, carácter y horas en la piel.'],
  };
  var OCC_WORDS = {
    diario: ['dia a dia', 'diario', 'universidad', 'viajes'],
    oficina: ['oficina', 'trabajo', 'dia a dia'],
    noche: ['noche', 'fiesta', 'salidas', 'rumba'],
    cita: ['cita', 'citas', 'noche'],
    eventos: ['evento', 'eventos', 'cena', 'especiales', 'regalo'],
  };

  var fam = function (p) { return list(p.families).map(norm); };
  var hasFam = function (p, names) { var f = fam(p); return names.some(function (n) { return f.indexOf(norm(n)) > -1; }); };
  var isSweet = function (p) { return hasFam(p, ['Gourmand', 'Dulce']); };
  var isFloral = function (p) { return hasFam(p, ['Floral']); };
  var isFresh = function (p) { return hasFam(p, ['Fresca', 'Aromática', 'Cítrica']); };
  var isWarm = function (p) { return hasFam(p, ['Ámbar', 'Especiada', 'Gourmand', 'Dulce']); };
  var intensityKey = function (p) {
    var n = norm(p.intensity);
    return n.indexOf('estela') > -1 ? 'estela' : n.indexOf('intima') > -1 ? 'intima' : n.indexOf('notoria') > -1 ? 'notoria' : '';
  };
  var momentKey = function (p) {
    var n = norm(p.moment);
    return n.indexOf('noche') > -1 ? 'noche' : n.indexOf('dia') > -1 ? 'dia' : n ? 'versatil' : '';
  };
  var effects = function (p) { return list(p.effects).map(norm); };
  var notesTop = function (p) { return list(p.notesTop); };
  var notesHeart = function (p) { return list(p.notesHeart); };
  var notesBase = function (p) { return list(p.notesBase); };

  function evaluate(p, a) {
    var s = 0, max = 0, why = [], caveat;
    var ik = intensityKey(p), mk = momentKey(p), ef = effects(p);
    var occ = norm(p.occasion);

    if (a.climate) {
      max += 3;
      if (a.climate === 'caliente') {
        if (isFresh(p) && ik !== 'estela') { s += 3; why.push('Aguanta el calor sin volverse pesado: ' + (join(notesTop(p).slice(0, 2), ' y ') || 'salida fresca') + ' al abrir.'); }
        else if (isFresh(p)) s += 2;
        else if (isWarm(p) && ik === 'estela') { s += 0.5; caveat = 'En tierra caliente rinde muchísimo: con 2 atomizaciones basta, y mejor de noche.'; }
        else s += 1.5;
      } else if (a.climate === 'frio') {
        if (isWarm(p)) { s += 3; why.push('Brilla en clima frío: el fondo de ' + (join(notesBase(p).slice(0, 2), ' y ') || 'ámbar') + ' se abre con el calor de tu piel.'); }
        else if (isFresh(p)) { s += 1.5; caveat = 'En frío los frescos se sienten más tímidos. Aplica también en la ropa.'; }
        else s += 2;
      } else if (a.climate === 'templado') { s += mk === 'versatil' ? 3 : 2.2; if (mk === 'versatil') why.push('Es versátil: funciona de día y de noche en clima templado.'); }
      else { s += mk === 'versatil' ? 3 : 1.8; if (mk === 'versatil') why.push('Se comporta igual en tierra caliente que en frío.'); }
    }

    if (a.occasion) {
      max += 3;
      var pts = 0, o = a.occasion;
      if (o === 'diario') pts = mk === 'versatil' ? 3 : ik !== 'estela' ? 2 : 1;
      if (o === 'oficina') pts = ik === 'estela' ? 0.5 : mk !== 'noche' ? 3 : 1.5;
      if (o === 'noche') pts = mk === 'noche' ? 3 : ik === 'estela' ? 2.2 : 1;
      if (o === 'cita') pts = ef.some(function (e) { return e === 'misterio' || e === 'dulzura'; }) ? 3 : ef.indexOf('elegancia') > -1 ? 2 : 1;
      if (o === 'eventos') pts = ef.some(function (e) { return e === 'elegancia' || e === 'presencia'; }) ? 3 : 1.5;
      var words = OCC_WORDS[o] || [];
      var hit = occ && words.some(function (w) { return occ.indexOf(w) > -1; });
      if (hit) pts = Math.min(3, pts + 1);
      s += pts;
      if (pts >= 3 && p.occasion) why.push('Lo curamos justo para eso: ' + p.occasion.charAt(0).toLowerCase() + p.occasion.slice(1) + '.');
      else if (pts >= 3) why.push({ diario: 'Sirve para el día a día sin cansar.', oficina: 'Correcto para la oficina: se nota sin invadir.', noche: 'Hecho para la noche y los planes largos.', cita: 'De los que se recuerdan de cerca.', eventos: 'Tiene la presencia que pide un evento.' }[o]);
      if (o === 'oficina' && ik === 'estela') caveat = caveat || 'Para oficina úsalo con una sola atomización.';
    }

    var likes = (a.likes || []).filter(function (l) { return l !== 'nose'; });
    if (likes.length) {
      max += 4;
      var hits = likes.filter(function (l) { return hasFam(p, LIKE_FAM[l] || []); });
      s += (hits.length / likes.length) * 4;
      if (hits.length) {
        var famTxt = list(p.families).slice(0, 3).join(' · ');
        why.push('Tiene ' + hits.map(function (h) { return LIKE_WORD[h]; }).join(' y ') + ' que te gusta' + (famTxt ? ' (' + famTxt + ').' : '.'));
      }
    } else if ((a.likes || []).indexOf('nose') > -1) {
      max += 4;
      s += p.favorite ? 4 : 2.5;
      if (p.favorite) why.push('Es de los más elegidos: un acierto seguro para empezar.');
    }

    if ((a.dislikes || []).indexOf('muy-dulce') > -1 && isSweet(p)) s -= 4;
    if ((a.dislikes || []).indexOf('muy-floral') > -1 && isFloral(p)) s -= 4;
    if ((a.dislikes || []).indexOf('muy-fuerte') > -1) {
      if (ik === 'estela') s -= 3;
      else if (ik === 'intima') why.push('Es de intensidad íntima: no incomoda a nadie alrededor.');
    }

    if (a.effect) {
      max += 3;
      if (ef.indexOf(a.effect) > -1) {
        s += 3;
        why.push({ frescura: 'Transmite limpieza y frescura.', dulzura: 'Se siente cálido y cercano.', elegancia: 'Se lee elegante y pulido.', misterio: 'Tiene un fondo misterioso.', presencia: 'Proyecta seguridad apenas entras.' }[a.effect]);
      }
    }

    if (a.presence && ik) {
      max += 3;
      var d = Math.abs(INT.indexOf(ik) - INT.indexOf(PRES[a.presence]));
      s += d === 0 ? 3 : d === 1 ? 1.2 : 0;
      if (d === 0) {
        var extra = [p.intensity, p.projection ? 'proyección ' + String(p.projection).toLowerCase() : '', p.duration ? 'dura ' + p.duration : ''].filter(Boolean).join(' · ');
        why.push('Intensidad justo como la pediste: ' + extra + '.');
      }
    }

    if (a.budget && a.budget !== 'igual') {
      max += 2;
      var r = BUDGET[a.budget];
      if (p.price >= r[0] && p.price <= r[1]) { s += 2; why.push('Está dentro de tu presupuesto.'); } else s += 0.6;
    }

    if (!p.available) s -= 5;

    if (!caveat && list(p.notFor).length) {
      var nf = list(p.notFor)[0].replace(/^Tal vez no,\s*/i, '').replace(/\.$/, '');
      caveat = 'No es el ideal ' + nf.charAt(0).toLowerCase() + nf.slice(1) + '.';
    }

    return { p: p, score: Math.max(0, s) - (p.rank || 0) * 0.01, max: max || 1, why: why.filter(Boolean).slice(0, 3), caveat: caveat };
  }

  function specRow(p) {
    var items = [p.concentration, p.volume, p.duration ? 'Dura ' + p.duration : '', p.projection ? 'Proyección ' + String(p.projection).toLowerCase() : ''].filter(Boolean);
    return items.length ? '<ul class="qspec">' + items.map(function (i) { return '<li>' + esc(i) + '</li>'; }).join('') + '</ul>' : '';
  }
  function notesRow(p) {
    var parts = [];
    if (notesTop(p).length) parts.push('<span><em>Abre en</em> ' + esc(join(notesTop(p).slice(0, 3))) + '</span>');
    if (notesHeart(p).length) parts.push('<span><em>Se asienta en</em> ' + esc(join(notesHeart(p).slice(0, 3))) + '</span>');
    if (notesBase(p).length) parts.push('<span><em>Se queda en</em> ' + esc(join(notesBase(p).slice(0, 3))) + '</span>');
    return parts.length ? '<p class="qnotes">' + parts.join('<i aria-hidden="true">·</i>') + '</p>' : '';
  }
  function famChips(p) {
    var f = list(p.families).slice(0, 3);
    return f.length ? '<ul class="qfam">' + f.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '';
  }

  var Quiz = {
    step: 0,
    a: { likes: [], dislikes: [] },
    reset: function () { this.step = 0; this.a = { likes: [], dislikes: [] }; },
    render: function () {
      if (this.step >= STEPS.length) return this.renderResult();
      var st = STEPS[this.step];
      var val = this.a[st.key];
      var isOn = function (v) { return Array.isArray(val) ? val.indexOf(v) > -1 : val === v; };
      var pct = Math.round((this.step / STEPS.length) * 100);
      var canNext = Array.isArray(val) ? val.length > 0 : Boolean(val);
      var left = STEPS.length - this.step;
      root.innerHTML = '<div class="ptest">' +
        '<div class="ptest__bar"><span>Pregunta ' + (this.step + 1) + ' de ' + STEPS.length + '</span><span>' + (left <= 2 ? 'Ya casi' : '≈ ' + Math.max(1, Math.ceil(left * 0.25)) + ' min') + '</span></div>' +
        '<div class="ptest__progress" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100"><span style="width:' + pct + '%"></span></div>' +
        '<fieldset class="ptest__step"><legend class="ptest__q">' + st.q + '</legend><p class="ptest__help">' + st.help + '</p>' +
        '<div class="ptest__opts ' + (st.options.length > 4 ? 'ptest__opts--grid' : '') + '">' +
        st.options.map(function (o, i) {
          return '<button type="button" class="popt ' + (isOn(o[0]) ? 'is-on' : '') + '" aria-pressed="' + isOn(o[0]) + '" data-opt="' + o[0] + '"' + (i === 0 ? ' data-autofocus' : '') + '>' +
            '<span class="popt__txt"><span class="popt__label">' + o[1] + '</span>' + (o[2] ? '<span class="popt__hint">' + o[2] + '</span>' : '') + '</span>' +
            '<span class="popt__mark" aria-hidden="true">' + (isOn(o[0]) ? '✓' : '') + '</span></button>';
        }).join('') + '</div></fieldset>' +
        '<div class="ptest__nav"><button type="button" class="textbtn" data-quiz-back ' + (this.step === 0 ? 'disabled' : '') + '>Atrás</button>' +
        (st.multi ? '<button type="button" class="btn btn--dark" data-quiz-next ' + (canNext ? '' : 'disabled') + '>Siguiente →</button>' : '<span class="ptest__auto">Elige una opción para continuar</span>') +
        '</div></div>';
    },
    choose: function (v) {
      var st = STEPS[this.step];
      if (st.multi) {
        var arr = (this.a[st.key] || []).slice();
        if (v === st.exclusive) arr = arr.indexOf(v) > -1 ? [] : [v];
        else {
          arr = arr.filter(function (x) { return x !== st.exclusive; });
          arr = arr.indexOf(v) > -1 ? arr.filter(function (x) { return x !== v; }) : arr.concat([v]).slice(-st.multi);
        }
        this.a[st.key] = arr;
        this.render();
      } else {
        this.a[st.key] = v;
        this.render();
        var self = this;
        setTimeout(function () { self.next(); }, 240);
      }
    },
    next: function () {
      if (this.step === STEPS.length - 1) track('quiz_complete', { likes: (this.a.likes || []).join(','), dislikes: (this.a.dislikes || []).join(','), effect: this.a.effect, presence: this.a.presence });
      this.step += 1;
      this.render();
      var body = root.closest('.drawer__body');
      if (body) body.scrollTo(0, 0);
    },
    renderResult: function () {
      var a = this.a;
      var pool = data.filter(function (p) {
        if (a.who === 'ella' || a.who === 'regalo-ella') return p.gender !== 'el';
        if (a.who === 'el' || a.who === 'regalo-el') return p.gender !== 'ella';
        return true;
      });
      var res = pool.map(function (p) { return evaluate(p, a); }).sort(function (x, y) { return y.score - x.score; }).slice(0, 3);
      var prof = PROFILE[a.effect || 'elegancia'];
      var profile = prof[0] + ' ' + PRES_WORD[a.presence || 'notorio'];
      var label = function (k) {
        var st = STEPS.filter(function (s) { return s.key === k; })[0];
        if (!st) return '';
        var o = st.options.filter(function (x) { return x[0] === a[k]; })[0];
        return o ? o[1] : '';
      };
      var chips = ['climate', 'occasion', 'presence', 'budget'].map(label).filter(Boolean);
      var gift = String(a.who || '').indexOf('regalo') === 0;
      var waMsg = 'Hola, Mouillette. Hice el test y me salió el perfil "' + profile + '". Me recomendaron: ' + res.map(function (r) { return r.p.title; }).join(', ') + '. ¿Cuál me recomiendan?';

      root.innerHTML = '<div class="ptest ptest--result">' +
        '<header class="presult__head">' +
          '<div class="presult__profile"><p class="eyebrow eyebrow--gold">Tu perfil olfativo</p><p class="presult__name">' + profile + '</p>' +
          '<p class="presult__copy">' + prof[1] + '</p><ul class="presult__chips">' + chips.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul></div>' +
          '<div class="presult__intro"><p class="presult__title">' + (gift ? 'Con estos aciertas.' : 'Estos son para ti.') + '</p>' +
          '<p>Los elegimos cruzando tus respuestas con la ficha de cada perfume: familia olfativa, notas, intensidad, duración y ocasión. Si dudas entre dos, escríbenos.</p></div>' +
        '</header>' +
        (res.length ? '<ol class="presult__list">' + res.map(function (r, i) {
          var p = r.p;
          var pct = Math.min(98, Math.round((r.score / r.max) * 100));
          var img = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '';
          return '<li class="prec ' + (i === 0 ? 'prec--top' : '') + '">' +
            '<a href="' + esc(p.url) + '" class="prec__img" tabindex="-1" aria-hidden="true">' + img + (i === 0 ? '<span class="prec__flag">Tu mejor opción</span>' : '') + '</a>' +
            '<div class="prec__body">' +
              '<div class="prec__top"><div><p class="prec__brand">' + esc(p.vendor) + '</p><p class="prec__name">' + esc(p.title) + '</p></div>' +
              '<div class="affinity" aria-label="' + pct + '% de afinidad"><svg viewBox="0 0 36 36" aria-hidden="true"><circle cx="18" cy="18" r="15.5" class="affinity__track"/><circle cx="18" cy="18" r="15.5" class="affinity__bar" stroke-dasharray="' + (pct / 100) * 97.4 + ' 97.4"/></svg><span>' + pct + '%</span></div></div>' +
              famChips(p) + specRow(p) +
              (p.micro ? '<p class="prec__micro">' + esc(p.micro) + '</p>' : '') +
              notesRow(p) +
              '<ul class="prec__why">' + r.why.map(function (w) { return '<li><span aria-hidden="true">✓</span> ' + w + '</li>'; }).join('') + '</ul>' +
              (r.caveat ? '<p class="prec__caveat"><strong>Ten en cuenta:</strong> ' + esc(r.caveat) + '</p>' : '') +
              (p.inspired ? '<p class="qinsp">' + esc(p.inspired) + '</p>' : '') +
              '<div class="prec__buy"><span class="price price--lg">' + esc(p.priceFormatted) + '</span>' +
              '<div class="prec__actions"><a href="' + esc(p.url) + '" class="btn btn--line">Ver perfume</a>' +
              (p.available && !p.multiVariant ? '<button type="button" class="btn btn--dark" data-quick-add data-variant-id="' + p.id + '" data-source="quiz">Añadir al carrito</button>' : '<a href="' + esc(p.url) + '" class="btn btn--dark">Elegir</a>') +
              '</div></div>' +
            '</div></li>';
        }).join('') + '</ol>' : '<p>Aún no hay perfumes configurados para el test. Revisa la colección del test en Configuración del tema.</p>') +
        '<div class="presult__foot">' +
          (MOU.settings && MOU.settings.whatsapp ? '<a class="btn btn--gold btn--lg" href="https://wa.me/' + MOU.settings.whatsapp + '?text=' + encodeURIComponent(waMsg) + '" target="_blank" rel="noopener noreferrer" data-track="whatsapp_click" data-track-context="quiz_result">Confirmar con un asesor</a>' : '') +
          '<button type="button" class="textbtn" data-quiz-restart>Repetir el test</button>' +
        '</div></div>';
    },
  };

  document.addEventListener('mou:drawer:quiz', function () {
    if (Quiz.step === 0 || Quiz.step >= STEPS.length) { Quiz.reset(); track('quiz_start', {}); }
    Quiz.render();
  });
  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-opt]');
    if (opt) Quiz.choose(opt.dataset.opt);
    if (e.target.closest('[data-quiz-back]')) { Quiz.step = Math.max(0, Quiz.step - 1); Quiz.render(); }
    if (e.target.closest('[data-quiz-next]')) Quiz.next();
    if (e.target.closest('[data-quiz-restart]')) { Quiz.reset(); Quiz.render(); }
  });
  Quiz.render();
})();
